var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"mb-2",attrs:{"name":"header"}}),_c('div',[_c('router-view',{key:_vm.$route.fullPath}),_c('notifications',{attrs:{"position":"top center","group":"main"}}),_c('dialogs',{ref:"Dialogs"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }